import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from '@mui/material';
import httpRequest from '../utils/httpRequest';

const FinancialYearDialog = ({ open, onClose, onFinancialYearCreated }) => {
  const [financialYear, setFinancialYear] = useState({
    description: '',
    start_date: '',
    end_date: '',
  });

  const handleChange = (e) => {
    setFinancialYear({
      ...financialYear,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    try {
      // Adjust the endpoint as necessary.
      await httpRequest('invoice/addFinancialYear', 'POST', financialYear);
      onFinancialYearCreated();
      onClose();
      setFinancialYear({
        description: '',
        start_date: '',
        end_date: '',
      });
    } catch (err) {
      console.error('Error adding financial year:', err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add New Financial Year</DialogTitle>
      <DialogContent>
        <TextField
          label="Start Date"
          type="date"
          fullWidth
          margin="normal"
          name="start_date"
          value={financialYear.start_date}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="End Date"
          type="date"
          fullWidth
          margin="normal"
          name="end_date"
          value={financialYear.end_date}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="Description"
          name="description"
          value={financialYear.description}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FinancialYearDialog;